import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

export interface IBlockComponentConfiguration extends CM.DOMComponent.IConfiguration {
};

export class BlockComponent extends CM.DOMComponent<
	HTMLDivElement,
	BlockComponent,
	IBlockComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IBlockComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
	};
};
export namespace NS {
	export const Component = BlockComponent;
	export type Component = BlockComponent;
	export type Configuration = IBlockComponentConfiguration;
}
;
CM.declare({
	id :   'block',
	type : BlockComponent
});
